module.exports = __webpack_public_path__ + "img/img12.ca6adca2.png";